/**
 * The editor's language ids and completion shape, kept apart from `monacoSetup` so that importing
 * them does not import Monaco (AU-69).
 *
 * Monaco and its HTML language service are about 1.5 MB. `TemplateEditor` is reachable from the
 * shared component barrel, so a static import of `monacoSetup` anywhere in that graph drags all
 * of it into the eager bundle — which is exactly what happened on the first cut of this change,
 * taking the entry chunk to 4 MB. These two declarations are what the component needs before
 * Monaco has loaded; everything else waits for the dynamic import.
 */

/** HTML-with-Handlebars, for email bodies. */
export const HANDLEBARS_LANGUAGE = 'handlebars';

/** Plain text, for SMS bodies. */
export const PLAINTEXT_LANGUAGE = 'plaintext';

/** A token or helper the editor offers while typing, built from the server's metadata endpoint. */
export interface EditorCompletion {
  /** What gets inserted — `{{Request.Type}}`, or an `{{#each}}` block. */
  insertText: string;
  /** What the list shows — the dotted path, or the helper name. */
  label: string;
  /** Right-hand detail: the sample value, or the helper's one-line summary. */
  detail?: string;
  /** Required tokens sort to the top; the editor also badges them. */
  required?: boolean;
  /** Grouping shown under the label. */
  group: string;
}
